import APIRequestState from './_util/api-request';

/** body: {email} */
class UnsubscribeState extends APIRequestState {
  get method() { return 'POST'; }
  get url() { return '/users/unsubscribe'; }
}

export default UnsubscribeState;



// WEBPACK FOOTER //
// ./spa/state/unsubscribe.jsx